import React, { useState } from "react";
import InView from "react-intersection-observer";
import ImageImpact from "../../images/pod-impact.png";
import Parallax from "../common/utils/animations/parallax";
import HeaderAnim from "../common/utils/animations/textRevealAnimation";
import LazyLoad from 'react-lazyload';

export default function Impact() {
  const [isVisible, setisVisible] = useState(false);
  return (
    <InView as="div" className="section-gap-large pod-cb-impact" onChange={(inView) => setisVisible(inView)} threshold={[0.4]}>
      <div className="container">
        <div className="cb-impact-inner">
          <div className="row d-flex align-v-center flex-wrap">
            <Parallax classes="col cb-impact-image" id="cb-impact-image" opacity={true} >
              <LazyLoad>
                <img src={ImageImpact} title="Delivering ROI" alt="Delivering ROI" />
              </LazyLoad>
            </Parallax>
            <div className="col cb-impact-content">
              <h2 className="theme-color-title cb-blue-color-1">{isVisible ? <HeaderAnim header="THE IMPACT" /> : ""}</h2>
              <h3>Delivering ROI and gearing up for growth</h3>
              <p>By automating the entire last-mile delivery process, including proof of delivery, the client realized a significant boost in logistics operational efficiency while enhancing flexibility and interoperability. The increased on-time deliveries and the significant decrease in delivery delays and failures resulted in a higher customer satisfaction rate and a consolidated delivery efficiency improvement.</p>

              <p>With a streamlined process, reduced paperwork, and better access to information, the client achieved a decline in invoicing errors, improved productivity, and business profitability.  With a streamlined process, reduced paperwork, and better access.</p>
            </div>
          </div>
        </div>
      </div>
    </InView>
  );
}